// 热点内容右侧广告
import React from 'react'
import { useAdData } from '../context'
import get from 'lodash/get'
import Label from './label'
import { useAdStat } from 'Components/ad'
import { RightButtonBannerAd } from './interface'
import applyHttpsImage from 'lib/apply-https-img'

interface IProps {
  /**
   * 如果没有广告，就展示children内容
   */
  children: Exclude<React.ReactChild, string | number>
}

const HotNewsRightAD: React.FC<IProps> = ({ children }) => {
  const adData = useAdData()
  const hotNewsAd = adData ? adData.right_button_banner_ad : undefined

  // 广告还未加载时为undefined, 加载完毕后仍未空则代表没有广告
  if (adData === undefined) {
    return (
      <div>
        <style jsx>
          {`
            div {
              float: right;
              position: relative;
              width: 380px;
              height: 250px;
              background: #f5f5f5;
            }
          `}
        </style>
      </div>
    )
  }

  if (!hotNewsAd || Object.keys(hotNewsAd).length === 0) {
    return children
  }
  return <AdItem data={hotNewsAd} />
}

function AdItem({ data }: { data: RightButtonBannerAd }) {
  const { ref, handleClick } = useAdStat(
    {
      send: 'ad_send_hot_news_picture',
      show: 'ad_show_hot_news_picture',
      click: 'ad_click_hot_news_picture',
    },
    data
  )
  return (
    <div className="hot_right_news_wrapper">
      <div className="scale-container">
        <div
          ref={ref}
          className="bg_img"
          onClick={() => {
            handleClick()
            setTimeout(() => {
              window.open(data.web_url, '_blank')
            }, 50)
          }}
        />
        <Label text={data.label} />
      </div>
      <p className="hot_news_title">{data.title || ''}</p>
      <style jsx>
        {`
          .hot_right_news_wrapper {
            width: 380px;
            overflow: hidden;
            display: inline-block;
            height: 305px;
          }
          .scale-container {
            width: 380px;
            height: 250px;
            overflow: hidden;
            position: relative;
          }
          .bg_img {
            position: relative;
            width: 100%;
            height: 100%;
            background: url(${applyHttpsImage(data.image.url)}) center center /
              cover no-repeat;
            object-fit: cover;
            object-position: 0 0;
            transition: transform 0.3s ease-in-out;
          }
          .bg_img :hover {
            transform: scale(1.1);
          }
          .hot_news_title {
            height: 52px;
            line-height: 52px;
            font-size: 16px;
            color: rgb(31, 33, 41);
            font-weight: 500;
            padding: 0 16px;
            border-radius: 0 0 2px 2px;
            color: #1f2129;
            background-color: #f2f4fa;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        `}
      </style>
    </div>
  )
}
export default HotNewsRightAD
